import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { getRsvpDeadlineFormValidationSchema } from '@bridebook/web/lib/wedding-website/utils/validation';
import { useWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';

export interface IRsvpDeadlineFormFields {
  deadline?: string;
}

export const useRsvpDeadlineForm = () => {
  const { t } = useTranslation('weddingWebsite');
  const { data: weddingRsvp } = useWeddingRsvp();

  const form = useForm<IRsvpDeadlineFormFields>({
    resolver: zodResolver(getRsvpDeadlineFormValidationSchema(t)),
    mode: 'onChange',
    defaultValues: {
      deadline: weddingRsvp?.deadline?.toDate().toISOString().split('T')[0] || '',
    },
  });

  useEffect(() => {
    if (!weddingRsvp?.deadline) {
      if (form.getValues('deadline')) {
        form.setValue('deadline', '', { shouldValidate: true });
      }
      return;
    }
    const isoDate = weddingRsvp.deadline.toDate().toISOString().split('T')[0];
    if (form.getValues('deadline') !== isoDate && !form.formState.isDirty) {
      form.setValue('deadline', isoDate, { shouldValidate: true });
    }
  }, [weddingRsvp?.deadline, form]);

  // Validate on mount so isValid reflects the default value (e.g. past deadline)
  useEffect(() => {
    form.trigger();
  }, [form]);

  return form;
};
